import React from 'react';
import { useTranslation } from 'react-i18next';
import SVGImage from '../layout/SVGImage';

interface ForecastDownloadButtonProps {
  onClick: () => void;
}

const ForecastDownloadButton: React.FC<ForecastDownloadButtonProps> = ({
  onClick,
}) => {
  const { t } = useTranslation();

  return (
    <button
      className="inline-flex cursor-pointer items-center rounded-[5px] bg-dark-4 py-[9px] pl-[17px] pr-[14px] drop-shadow-1 hover:bg-[#092740]"
      onClick={onClick}
    >
      <SVGImage name="forecast-download" />
      <p className="noto-13-medium ml-[7px] text-white">
        {t('forecast.download')}
      </p>
    </button>
  );
};

export default ForecastDownloadButton;
